import { ConfigurationSourceDataMap, Institution, Metadata, Participant, MasterGroup, CoordinatingGroup, SourceData, Trial, UpdateStatusEvent } from "@/api/dtos";
import IsLoading from "@/components/layouts/IsLoading";
import Show from "@/components/layouts/Show";
import ParticipantSourceDataFormStatusList, { ParticipantSourceDataFormStatusListItemType } from "@/components/lists/status/ParticipantSourceDataFormStatusList";
import ParticipantSourceDataFormStatusesContext from "@/contexts/data/ParticipantSourceDataFormStatusesContext";
import SourceDataFormContext from "@/contexts/form/SourceDataFormContext";
import useParticipantSourceDataEventStatuses from "@/hooks/data/useParticipantSourceDataEventStatuses";
import useParticipantSourceDataFormStatuses from "@/hooks/data/useParticipantSourceDataFormStatuses";
import useStatusUpdate from "@/hooks/data/useStatusUpdate";
import useEvent from "@/hooks/form/source-data/useEvent";
import useForms from "@/hooks/form/source-data/useForms";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Alert, AlertTitle, Divider, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Paper } from "@mui/material";
import { FC, useCallback, useContext, useMemo } from "react";
import { Link } from "react-router-dom";

interface ISourceDataFormsProps {
    trial: Trial;
    masterGroup?: MasterGroup;
    coordinatingGroup?: CoordinatingGroup;
    institution?: Institution;
    participant: Participant;
    metadata: Metadata;
    trialConfiguration: ConfigurationSourceDataMap;
    configuration: ConfigurationSourceDataMap;
    sourceData: SourceData;
    studyEventOid: string;
    studyEventRepeat: number;
    preview?: boolean;
}

const SourceDataForms: FC<ISourceDataFormsProps> = ({
    trial,
    masterGroup,
    coordinatingGroup,
    institution,
    participant,
    metadata,
    trialConfiguration,
    configuration,
    sourceData,
    studyEventOid,
    studyEventRepeat,
    preview
}) => {
    const { idMap: formStatusMapping, refresh: statusesRefresh } = useContext(ParticipantSourceDataFormStatusesContext);
    const {  queueUpdate } = useContext(SourceDataFormContext);
    
    const statusMapping = useMemo(() => {
        return formStatusMapping?.[studyEventOid]?.[studyEventRepeat]
    }, [formStatusMapping, studyEventOid, studyEventRepeat])
    
    const formData = useForms(
        metadata,
        trialConfiguration,
        configuration,
        sourceData,
        trial,
        masterGroup,
        coordinatingGroup,
        institution,
        participant,
        studyEventOid,
        studyEventRepeat,
        preview
    );

    return (
        <>
            <ParticipantSourceDataFormStatusList 
                trial={trial}
                institution={institution}
                participant={participant}
                data={formData}
                statuses={statusMapping}
                queueUpdate={queueUpdate}
            />
        </>
    )
};

export default SourceDataForms;